import { FC } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { keycloakGoogleSSOLoginURL } from '@features/auth';
import { useDirection } from '@hooks';
import { Trans } from '@libs/i18n';
import { NoFlipButton } from '@utils';

interface LoginSSOProps {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}
export const LoginSSO: FC<LoginSSOProps> = observer(
  ({ isLoading, setIsLoading }: LoginSSOProps) => {
    const { dir } = useDirection();
    const handleGoogleLogin = () => {
      setIsLoading(true);
      keycloakGoogleSSOLoginURL();
    };

    return (
      <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
        <Stack
          direction="column"
          spacing={2}
          alignItems="center"
          sx={{ width: '100%', maxWidth: '452px' }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            alignItems="center"
            sx={{ width: '100%' }}
          >
            <Box
              sx={{
                border: '1px solid #E5E4E4C4',
                borderRadius: '12px',
                width: '62px',
                height: '62px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                component="img"
                src="/logo.svg"
                alt="komplyance logo"
                sx={{ width: '53px', height: '45px', objectFit: 'contain' }}
              />
            </Box>

            <Typography
              variant="body1"
              textAlign="center"
              fontSize={24}
              fontWeight={600}
              sx={{
                maxWidth: '452px',
                width: '100%',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            >
              <Trans i18nKey="auth.login.form.title" />
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              fontSize={16}
              fontWeight={500}
              sx={{
                maxWidth: '430px',
                width: '100%',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                color: '#8F8F8F',
              }}
            >
              <Trans i18nKey="auth.login.form.description" />
            </Typography>
          </Box>
          <NoFlipButton
            mode={dir}
            onClick={handleGoogleLogin}
            disabled={isLoading}
            sx={{
              maxWidth: '452px',
              width: '100%',
              minHeight: '45px',
              borderRadius: '12px',
              border: '1px solid',
              borderColor: '#8F8F8F',
              padding: '12px 20px',
              gap: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textTransform: 'none',
              backgroundColor: 'transparent',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}
          >
            {isLoading ? (
              <CircularProgress size={20} sx={{ color: '#8F8F8F' }} />
            ) : (
              <Box
                component="img"
                src="/Google.svg"
                alt="google logo"
                sx={{ width: '24px', height: '24px' }}
              />
            )}
            <Typography variant="body1">
              <Trans i18nKey="auth.login.form.button.google" />
            </Typography>
          </NoFlipButton>
        </Stack>
      </Box>
    );
  },
);
